import { atomWithStorage } from 'jotai/utils'
import type { Country } from 'internal-types/country.type'

export const countryAtom = atomWithStorage<Country | undefined>(
  'countryAtom',
  undefined
)
